export enum LanguagesEnv { Ahumada = 'ahumada', Benavides = 'benavides' };